import React from 'react'
import { MuiTextfield } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const {
  helpers: {
    keepInLength,
    calculatePeriod,
    getUserProfileLocal,
    calculateFlag,
    getUserId,
    getLoginFromMail
  }
} = core

const {
  decision,
  theirRole,
  visitType,
  judgement,
  themeNoL1,
  themeNoL2,
  themeDescriptionL1,
  themeDescriptionL2,
  centreActionStatus
} = commonConfigValues

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const valueTable = {}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      // 'register.ui',
      'register.sector',
      'register.organizationName',
      'register.name',
      'inspection.inspectionType',
      'inspection.inspectionDate',
      // 'LINE 1 THEME',
      // 'LINE 2 THEME',
      'action.actionsAgreed',
      'action.originalDueDate',
      'action.revisedDueDate',
      'action.status',
      'action.validFrom',
      'action.flag'
    ]
  }
]

export const defaultSorting = [
  { columnName: 'inspection.inspectionDate', direction: 'asc' }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Centre UI',
    minSpace: 'Centre UI ',
    getCellValue: row => row['id'],
    formField: true
  },
  {
    name: 'register.sector',
    title: 'Centre Sector',
    minSpace: 'Centre Sector ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'register.organisationName',
    title: 'Centre Organisation Name',
    minSpace: 'Centre Organisation ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'register.name',
    title: 'Centre / Unit Name',
    // hidden: true,
    minSpace: 'Centre / Unit ',
    formField: true
  },

  {
    name: 'inspection.hiqaCenter',
    title: 'HIQA Centre ID No.',
    formField: true,
    minSpace: 'HIQA Centre ID No. '
  },
  {
    name: 'inspection.hiqaInspection',
    title: 'HIQA Inspection ID No.',
    formField: true,
    minSpace: 'HIQA Inspection ID No. '
  },

  {
    name: 'inspection.inspectionType',
    title: 'Inspection Type ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(visitType, ['id', parseInt(row[`inspection.inspectionType`], 10)])
        ? _.find(visitType, [
            'id',
            parseInt(row[`inspection.inspectionType`], 10)
          ]).label
        : row[`inspection.inspectionType`],
    options: 'visitType',
    filterField: true,
    minSpace: 'Inspection Type '
  },
  {
    name: 'inspection.inspectionDate',
    title: 'Inspection Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Inspection '
  },
  {
    name: 'inspection.publicationDate',
    title: 'Publication Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Publication '
  },
  {
    name: 'inspection.publicationTimeframe',
    title: 'Inspection / Publication Timeframe',
    formField: true,
    getCellValue: row =>
      calculatePeriod(
        row[`inspection.inspectionDate`],
        row[`inspection.publicationDate`]
      ),
    // filterField: true,
    minSpace: 'Inspection / Publication '
  },
  {
    name: 'inspection.inspectorName',
    title: 'Inspector Name(s)',
    formField: true,
    // filterField: true,
    minSpace: 'Inspector Name(s) '
  },
  {
    name: 'inspection.inspectorRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`inspection.inspectorRole`], 10)])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`inspection.inspectorRole`], 10)
          ]).label
        : row[`inspection.inspectorRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'inspection.themeNoL1',
    title: 'Inspected Standard / Theme ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeNoL1, ['id', parseInt(row[`inspection.themeNoL1`], 10)])
        ? _.find(themeNoL1, ['id', parseInt(row[`inspection.themeNoL1`], 10)])
            .label
        : row[`inspection.themeNoL1`],
    options: 'themeNoL1',
    filterField: true,
    minSpace: 'Inspected Standard / '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'inspection.themeDescriptionL1',
    title: 'Inspected Standard / Theme Description',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeDescriptionL1, [
        'id',
        parseInt(row[`inspection.themeDescriptionL1`], 10)
      ])
        ? _.find(themeDescriptionL1, [
            'id',
            parseInt(row[`inspection.themeDescriptionL1`], 10)
          ]).label
        : row[`inspection.themeDescriptionL1`],
    options: 'themeDescriptionL1',
    filterField: true,
    minSpace: 'Inspected Standard / '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'inspection.themeNoL2',
    title: 'Inspected Standard / Theme ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeNoL2, ['id', parseInt(row[`inspection.themeNoL2`], 10)])
        ? _.find(themeNoL2, ['id', parseInt(row[`inspection.themeNoL2`], 10)])
            .label
        : row[`inspection.themeNoL2`],
    options: 'themeNoL2',
    filterField: true,
    minSpace: 'Inspected Standard / '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'inspection.themeDescriptionL2',
    title: 'Inspected Standard / Theme Description',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeDescriptionL2, [
        'id',
        parseInt(row[`inspection.themeDescriptionL2`], 10)
      ])
        ? _.find(themeDescriptionL2, [
            'id',
            parseInt(row[`inspection.themeDescriptionL2`], 10)
          ]).label
        : row[`inspection.themeDescriptionL2`],
    options: 'themeDescriptionL2',
    filterField: true,
    minSpace: 'Inspected Standard / '
  },
  {
    name: 'inspection.judgement',
    title: 'Inspection Judgements',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(judgement, ['id', parseInt(row[`inspection.judgement`], 10)])
        ? _.find(judgement, ['id', parseInt(row[`inspection.judgement`], 10)])
            .label
        : row[`inspection.judgement`],
    options: 'judgement',
    filterField: true,
    minSpace: 'Judgements '
  },

  {
    name: 'action.actionsRequired',
    title: 'Actions Required',
    formField: true,
    // filterField: true,
    minSpace: 'Actions Required '
  },
  {
    name: 'action.actionsAgreed',
    title: 'Agreed Actions',
    formField: true,
    // filterField: true,
    minSpace: 'Agreed Actions '
  },
  {
    name: 'action.responsiblePeople',
    title: 'Agreed Actions',
    formField: true,
    // filterField: true,
    minSpace: 'Agreed Actions '
  },
  {
    name: 'action.responsibleRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`action.responsibleRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`action.responsibleRole`], 10)])
            .label
        : row[`action.responsibleRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'action.originalDueDate',
    title: 'Original Action Due Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Original Action '
  },
  {
    name: 'action.revisedDueDate',
    title: 'Revised Action Due Date (I/A)',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Revised Action '
  },
  {
    name: 'action.informedChange',
    title: 'HIQA Informed of Change in Due Date?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`action.informedChange`], 10)])
        ? _.find(decision, ['id', parseInt(row[`action.informedChange`], 10)])
            .label
        : row[`action.informedChange`],
    options: 'decision',
    filterField: true,
    minSpace: 'HIQA Informed of Change in '
  },
  {
    name: 'action.status',
    title: 'Action Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(centreActionStatus, ['id', parseInt(row[`action.status`], 10)])
        ? _.find(centreActionStatus, ['id', parseInt(row[`action.status`], 10)])
            .label
        : row[`action.status`],
    options: 'centreActionStatus',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'action.validFrom',
    title: 'Action Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'action.flag',
    title: 'Agreed Action Flags',
    formField: true,
    filterField: true,
    minSpace: 'Agreed Action Flags '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues,
  activeFormName
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'inspection',
      historyName: 'inspectionHistory',
      label: 'Centre',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Centre Entry',
          // hint: 'Select Centre Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.name} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'ins',
      activeName: 'inspection',
      historyName: 'inspectionHistory',
      label: 'Inspections',
      icon: 'note',
      fields: [
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.hiqaCenter',
            label: 'HIQA Centre ID No.',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            // hint: 'Enter ID',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 10)
              return val.toUpperCase()
            },
            validate: v =>
              activeFormName !== 'ins' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.hiqaInspection',
            label: 'HIQA Inspection ID No.',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            // hint: 'Enter ID',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 10)
              return val.toUpperCase()
            },
            validate: v =>
              activeFormName !== 'ins' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.inspectionType',
            label: 'Inspection Type',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            // hint: 'Select Inspection Type',
            required: showAsterix,
            options: availableValues.visitType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'ins' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.inspectionDate',
            label: 'Inspection Date',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required'),
            onChange: (e, v) => {
              change(
                formName,
                'inspection.publicationTimeframe',
                calculatePeriod(
                  v,
                  _.get(formValues, 'inspection.publicationDate')
                )
              )
            }
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.publicationDate',
            label: 'Publication Date',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'ins' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            onChange: (e, v) => {
              change(
                formName,
                'inspection.publicationTimeframe',
                calculatePeriod(
                  v,
                  _.get(formValues, 'inspection.inspectionDate')
                )
              )
            }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculatePeriod(
                  formValues &&
                    formValues.inspection &&
                    formValues.inspection.inspectionDate,
                  formValues &&
                    formValues.inspection &&
                    formValues.inspection.publicationDate
                )}
                label={'Inspection / Publication Timeframe'}
              />
            ),
            name: 'inspection.publicationTimeframe',
            label: 'Inspection / Publication Timeframe',
            disabled: true
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.inspectorName',
            label: 'Inspector Name(s)',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            // hint: 'Enter Name',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'ins' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'inspection.inspectorRole',
            label: 'Their Role(s)',
            disabled: !add && (disabled || activeFormName !== 'ins'),
            // hint: 'Select Their Role',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'ins' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ]
      ]
    },
    {
      id: 3,
      name: 'act',
      activeName: 'action',
      historyName: 'actionHistory',
      label: 'Actions',
      icon: 'note',
      fields: [
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'action.actionsRequired',
          label: 'Actions Required ',
          disabled: !add && (disabled || activeFormName !== 'act'),
          // hint: 'Enter Actions',
          required: showAsterix,
          // normalize: v => {
          //   const val = keepInLength(v, 10)
          //   return val
          // }
          validate: v =>
            activeFormName !== 'act' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'action.actionsAgreed',
          label: 'Actions Agreed ',
          disabled: !add && (disabled || activeFormName !== 'act'),
          // hint: 'Enter Actions',
          required: showAsterix,
          // normalize: v => {
          //   const val = keepInLength(v, 10)
          //   return val
          // }
          validate: v =>
            activeFormName !== 'act' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'action.responsible',
            label:
              'Person / People Responsible for Implementing this Action Name(s)',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Enter Responsible People',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.responsibleRole',
            label: 'Their Role(s)',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Select Their Role',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.originalDueDate',
            label: 'Original Action Due Date',
            disabled: !add && (disabled || activeFormName !== 'act'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'action.flag',
                calculateFlag(
                  (formValues &&
                    formValues.action &&
                    formValues.action.revisedDueDate) ||
                    v
                )
              )
            },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.revisedDueDate',
            label: 'Revised Action Due Date (I/A)',
            disabled: !add && (disabled || activeFormName !== 'act'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(formName, 'action.flag', calculateFlag(v))
            },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.informedChange',
            label: 'HIQA Informed of Change in Due Date?',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Select Status',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.status',
            label: 'Action Status',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Select Status',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.centreActionStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.validFrom',
            label: 'Action Status Valid at Date',
            disabled: !add && (disabled || activeFormName !== 'act'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          component: v => (
            <MuiTextfield
              style={styles.fieldText}
              disabled={true}
              input={{
                floatingLabelStyle: { ...styles.floatingLabel }
              }}
              value={calculateFlag(
                (formValues &&
                  formValues.action &&
                  formValues.action.revisedDueDate) ||
                  (formValues &&
                    formValues.action &&
                    formValues.action.originalDueDate)
              )}
              label={'Agreed Action Flags'}
            />
          ),
          name: 'action.flag',
          label: 'Agreed Action Flags'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['inspection', 'action']

export const errors = [1, 2]

export const defaultNew = {
  inspection: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  action: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  inspectionHistory: [],
  actionHistory: []
}

// "inspections": [
//   {
//   "id": 1,
//   "registerId": 1,
//  "inspection": {
//    "historyId":1,
//   "inspectionDate": "2001-01-01T23:28:56.782Z",
// },
// "inspectionHistory": []
//   }
// ]



// WEBPACK FOOTER //
// ./src/centre/configs/inspections.js